var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c("header", { staticClass: "tabs" }, [
      _c("div", { attrs: { id: "pestanas" } }, [
        _c(
          "ul",
          { attrs: { id: "lista_tabs" } },
          _vm._l(_vm.tabs, function(tab, index) {
            return _c(
              "li",
              {
                key: index,
                class: { "is-active_tab": tab.isActive },
                attrs: { id: "lista_tab" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "nav-item-tab",
                    on: {
                      click: function($event) {
                        return _vm.selectTab(tab)
                      }
                    }
                  },
                  [_vm._v("\n            " + _vm._s(tab.name) + "\n          ")]
                )
              ]
            )
          }),
          0
        )
      ])
    ]),
    _c("section", { staticClass: "tabs-details" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }